import { ThemeProvider } from '@mui/material';
import mikeSharedTheme from './styles/mikeSharedTheme';
import './index.css'
import App from './components/App'
import { IntlProvider } from "react-intl";
import { BrowserRouter as Router } from 'react-router-dom'
import messagesEn from "./messages/en";
import store from './store/store';
import { Provider } from 'react-redux';
import { IConfig } from './model/IConfig';

interface IndexProps {
  config: IConfig;
}

const language = "en";
const messages = { en: messagesEn };


const Index = (props: IndexProps) => {
  // const { login } = useOidc()
  const { config } = props

  return (
    <IntlProvider locale={language} messages={messages[language]}>                  
      <ThemeProvider theme={mikeSharedTheme}>
        {/* <CssBaseline /> */}
        <Provider store={store}>
          <Router>
            <App config={config}/>
          </Router>
        </Provider>
      </ThemeProvider> 
    </IntlProvider>
  )
};

export default Index
